import ApartmentsAPI from './apartments'
import i18n from '../translations/i18n'

export interface OpenAIResponse {
    result?: string
    error?: string
}
export async function runAIGenerationAndUpdateNotes(userId: string, apartmentId: string, information: any): Promise<void> {
    // console.log("runAIGenerationAndUpdateNotes")
    // console.log(apartmentId)
    // console.log(information)
    try {
        const message = [
            {
                role: 'system',
                content:
                    'Olet tekoälymalli, jonka rooli on toimia kiinteistönvälittäjänä. Kirjoita kattava ja myyvä vuokra-asunnon myynti-ilmoitus. Kirjoita esittelyteksti ilman väliotsikoita. Kuvaile ilmoituksessa asuntoa, sen ominaisuuksia, sijaintia sekä lähellä olevia palveluita. Kirjoita suomeksi. Älä kirjoita ilmoitukseen minkäänlaisia ohjeita ja/tai kehoituksia yhteydenottoon liittyen. Vastauksesi tulee olla enintään 1500 merkkiä pitkä tai 200 sanaa. Varmista, että teksti on kokonainen eikä katkea kesken kaiken. Asunto sijaitsee osoitteessa ' +
                    `${information.streetAddress} ${information.streetNumber}, ${information.postalArea}, ${information.postalCode}.`,
            },
            {
                role: 'user',
                content: `Asunto on ${i18n.t(`apartment.buildingType.${information.buildingType}`)}, joka on ${information.rooms}+${i18n.t(`apartment.kitchen.${information.kitchen}`)}${information.balcony ? `+${i18n.t(`apartment.balcony.${information.balcony}`)}${information.balcony !== 'no' ? ' parveke.' : ''}` : ''} ${information.floor ? `Asunto sijaitsee ${information.floor}${information.floors ? `/${information.floors}` : ''} kerroksessa.` : ''} ${information.dishwasher === 'yes'
                    ? 'Asunnossa on astianpesukone.' : information.dishwasher === 'installable'
                        ? 'Asunnossa on mahdollisuus asentaa astianpesukone.' : ''} ${information.laundryMachine === 'yes'
                            ? 'Asunnossa on pyykinpesukone.' : information.laundryMachine === 'installable'
                                ? 'Asunnossa on mahdollisuus asentaa pyykinpesukone.' : ''} Asunnon ominaisuudet ovat ${[
                                    information.internetIncluded ? 'internet' : '',
                                    information.petsAllowedCheckBoxProperty ? 'lemmikit sallittu' : '',
                                    information.hasSaunaCheckBoxProperty ? 'sauna' : '',
                                    information.hasElevator ? 'hissi' : '',
                                    information.isFurnished ? 'kalustettu' : '',
                                    information.hasBuiltInClosetCheckBoxProperty ? 'vaatehuone' : '',
                                    information.renovatedCheckBoxProperty ? 'remontoitu' : '',
                                    information.waterFeeBasis === 'included' ? 'vesimaksu sisältyy vuokraan' : '',
                                    information.firstRentDiscount50PercentCheckBoxProperty ? 'ensimmäinen vuokra 50% halvempi' : ''
                                ].filter(Boolean).join(', ')}.${(information.renovations || information.damages) ? ` Asunnossa on tehty seuraavat remontit: ${[
                                    information.renovations,
                                    information.damages
                                ].filter(Boolean).join('. ')}.` : ''}`
            },
            {
                role: 'system',
                content: `Tässä vuokranantajan itse kirjoittama teksti, jota tulisi käyttää osana esittelytekstiä. Älä mainitse, että teksti on vuokranantajan kirjoittama, vaan sisällytä se osaksi sinun kirjoittamaa tekstiä mahdollisimman paljon sanasta sanaan: ${information.notes}`
            }
        ]

        // Call the AI API (assuming a function callOpenAI exists)
        const aiResponse = await callOpenAI(message)

        if (aiResponse && aiResponse.result) {
            // Update apartment notes with AI-generated content
            const updatedApartmentInformation: any = {
                ...information,
                notes: aiResponse.result
            }

            // Make the API call to update the apartment information
            await ApartmentsAPI.updateApartmentInformation(userId, apartmentId, updatedApartmentInformation)
        } else {
            throw new Error('AI generation failed')
        }
    } catch (error) {
        console.error('Error generating AI content and updating notes:', error)
    }
}
export const callOpenAI = async (
    message: any,
): Promise<OpenAIResponse> => {
    //console.log(message)
    const openAIToken = process.env.REACT_APP_OPENAI_TOKEN || ''

    if (!openAIToken) {
        console.error("OpenAI token not found in environment variables.")
        return { error: 'Missing OpenAI token.' }
    }

    try {
        const response = await fetch('https://api.openai.com/v1/chat/completions', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${openAIToken}`,
            },
            body: JSON.stringify({
                model: 'gpt-4o',
                messages: message,
                temperature: 0.5,
                max_tokens: 700,
            })
        })

        if (response.ok) {
            const data = await response.json()
            const result = data.choices[0]?.message?.content.trim()
            return { result };
        } else {
            console.error("Error in response:", response.statusText)
            return { error: "An error occurred while calling the API" }
        }

    } catch (error) {
        console.error('Error calling OpenAI:', error)
        return { error: 'Failed to fetch response from OpenAI' }
    }
}
